import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../../shared/services/config.service';
import { UserService } from '../../../../shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeePortalService {

  //#976 BEA 2021-01-08 to force reading from localstorage each (and every) time
  private get httpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-employee-key',
        'SessionId': this.userService.sessionId
      })
    };
  }

  constructor(private http: HttpClient, private configService: ConfigService, private userService: UserService) { 
    
  }

  testAutoCalc(date): Observable<any> {
    
    let httpOptionsTime = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-time-key',
        'SessionId': this.userService.sessionId
      })
    };
    return this.http.get<any>(this.configService.config.timeUrl + `/api/AutoCalc/CalculateTimeAutoTestDate?date=${date}&userEmployeeId=${this.userService.account.EmployeeId}`, httpOptionsTime);
  }

  testAmlCalc(): Observable<any> {
    
    let httpOptionsTime = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-time-key',
        'SessionId': this.userService.sessionId
      })
    };
    return this.http.get<any>(this.configService.config.timeUrl + `/api/Aml/CalculateAml?companyId=${this.userService.account.CompanyId}&userEmployeeId=${this.userService.account.EmployeeId}`, httpOptionsTime);
  }

  calculateEmployeeDate(employeeId, date): Observable<any> {
    
    let httpOptionsTime = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-time-key',
        'SessionId': this.userService.sessionId
      })
    };
    return this.http.get<any>(this.configService.config.timeUrl + `/api/Calculate/CalculateEmployeeDate?employeeId=${employeeId}&date=${date}&userEmployeeId=${this.userService.account.EmployeeId}`, httpOptionsTime);
  }

  getEmployee(id: number): Observable<any> {
    return this.http.get<any>(this.configService.config.employeeUrl + '/api/employeeportal/GetEmployee/' + id, this.httpOptions);
  }

  getEmployeeBalance(id: number): Observable<any> {
    return this.http.get<any>(this.configService.config.directUrl + `/api/Balance/GetBalanceByEmployeeId?employeeId=${id}`, this.httpOptions);
  }

  getEmployeeDiagramResult(from: string, to: string, employeeId: number): Observable<any> {
    return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeeportal/GetEmployeeDiagramResult?from=${from}&to=${to}&employeeId=${employeeId}`, this.httpOptions);
  }

  getTimesByTimeTypeAndProject(from: string, to: string, filterEmployee: string): Observable<any> {
    return this.http.get<any>(this.configService.config.directUrl + `/api/Report/GetCustomerOverviewBySearch_EmployeePortal?from=${from}&to=${to}&filterEmployee=${filterEmployee}`, this.httpOptions);
  }

  getMyTimePosts(employeeId: number, from: string, to: string): Observable<any> {
    
    return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeeportal/GetMyTimePosts?employeeId=${employeeId}&from=${from}&to=${to}`, this.httpOptions);
  }

  getTimePostsStartStop(employeeId: number, from: string, to: string): Observable<any> {
    
    return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeeportal/GetTimePostsStartStop?employeeId=${employeeId}&from=${from}&to=${to}`, this.httpOptions);
  }

  //limitEmployees is true then only retrieve time posts to the employees that are supervised by the user.
  getListEmployeePortalAdmin_Combos(employeeId: number, limitEmployees: boolean, from: string, to: string, isAdmin: boolean, categoryStatusCombos: any[], projectIds?: number[]): Observable<any> {
    

    let viewModel = {
      EmployeeId: employeeId,
      LimitEmployees: limitEmployees,
      From: from,
      To: to,
      IsAdmin: isAdmin,
      CategoryIds: [],
      StatusIds: [],
      ProjectIds: projectIds ? projectIds : [],
      CategoryStatusCombos: categoryStatusCombos
    }

    return this.http.post<any>(this.configService.config.employeeUrl + "/api/employeeportal/GetListEmployeePortalAdmin", viewModel, this.httpOptions);
    // return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeeportal/GetListEmployeePortalAdmin?employeeId=${employeeId}&from=${from}&to=${to}&isAdmin=${isAdmin}&${categoryIds}&${statusIds}&${projectIds}`, this.httpOptions);
  }

  //limitEmployees is true then only retrieve time posts to the employees that are supervised by the user.
  getListEmployeePortalAdmin(employeeId: number, limitEmployees: boolean, from: string, to: string, isAdmin: boolean, categoryIds: number[], statusIds: number[], projectIds?: number[]): Observable<any> {
    

    //Eirik 10.12.19 task 154 - only show these combos of categories and statuses
    let categoryStatusCombos : any[] = [];
    categoryIds.forEach(categoryId => {
      statusIds.forEach(statusId => {
        categoryStatusCombos.push( {
          CategoryId: categoryId,
          StatusId: statusId
        })
      });
    });

    let viewModel = {
      EmployeeId: employeeId,
      LimitEmployees: limitEmployees,
      From: from,
      To: to,
      IsAdmin: isAdmin,
      CategoryIds: categoryIds,
      StatusIds: statusIds,
      ProjectIds: projectIds ? projectIds : [],
      CategoryStatusCombos: categoryStatusCombos
    }

    return this.http.post<any>(this.configService.config.employeeUrl + "/api/employeeportal/GetListEmployeePortalAdmin", viewModel, this.httpOptions);
    // return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeeportal/GetListEmployeePortalAdmin?employeeId=${employeeId}&from=${from}&to=${to}&isAdmin=${isAdmin}&${categoryIds}&${statusIds}&${projectIds}`, this.httpOptions);
  }

  //limitEmployees is true then only retrieve time posts to the employees that are supervised by the user.
  getListAdditions(employeeId: number, limitEmployees: boolean, from: string, to: string, isAdmin: boolean, categoryIds: number[], statusIds: number[], projectIds?: number[]): Observable<any> {
    //Eirik 10.12.19 task 154 - only show these combos of categories and statuses
    let categoryStatusCombos : any[] = [];
    categoryIds.forEach(categoryId => {
      statusIds.forEach(statusId => {
        categoryStatusCombos.push( {
          CategoryId: categoryId,
          StatusId: statusId
        })
      });
    });

    let viewModel = {
      EmployeeId: employeeId,
      LimitEmployees: limitEmployees,
      From: from,
      To: to,
      IsAdmin: isAdmin,
      CategoryIds: categoryIds,
      StatusIds: statusIds,
      ProjectIds: projectIds ? projectIds : [],
      CategoryStatusCombos: categoryStatusCombos
    }

    return this.http.post<any>(this.configService.config.employeeUrl + "/api/employeeportal/GetAdditions", viewModel, this.httpOptions);
  }

  //limitEmployees is true then only retrieve time posts to the employees that are supervised by the user.
  getListExpenses(employeeId: number, limitEmployees: boolean, from: string, to: string, isAdmin: boolean, categoryIds: number[], statusIds: number[], projectIds?: number[]): Observable<any> {
    //Eirik 10.12.19 task 154 - only show these combos of categories and statuses
    let categoryStatusCombos : any[] = [];
    categoryIds.forEach(categoryId => {
      statusIds.forEach(statusId => {
        categoryStatusCombos.push( {
          CategoryId: categoryId,
          StatusId: statusId
        })
      });
    });

    let viewModel = {
      EmployeeId: employeeId,
      LimitEmployees: limitEmployees,
      From: from,
      To: to,
      IsAdmin: isAdmin,
      CategoryIds: categoryIds,
      StatusIds: statusIds,
      ProjectIds: projectIds ? projectIds : [],
      CategoryStatusCombos: categoryStatusCombos
    }

    return this.http.post<any>(this.configService.config.employeeUrl + "/api/employeeportal/GetExpenses", viewModel, this.httpOptions);
  }

  getListBalances(employeeId: number, isSupervisor: boolean): Observable<any> {

    let viewModel = {
      EmployeeId: employeeId,
      isSupervisor: isSupervisor,
    }

    return this.http.post<any>(this.configService.config.employeeUrl + "/api/employeeportal/GetBalances", viewModel, this.httpOptions);
  }

  getListBalanceTimePosts(employeeId: number, balanceId: number, from: string, to: string): Observable<any> {

    let viewModel = {
      EmployeeId: employeeId,
      BalanceId: balanceId,
      DateFrom: from,
      DateTo: to,
    }

    return this.http.post<any>(this.configService.config.employeeUrl + "/api/employeeportal/GetTimeBankRecords", viewModel, this.httpOptions);
  }

  getListBalanceLogg(employeeId: number, balanceId: number, from: string, to: string): Observable<any> {

    let viewModel = {
      EmployeeId: employeeId,
      BalanceId: balanceId,
      DateFrom: from,
      DateTo: to,
    }

    return this.http.post<any>(this.configService.config.employeeUrl + "/api/employeeportal/GetEmployeeBalanceLogs", viewModel, this.httpOptions);
  }

  getEmployeesNotQuit(from: string): Observable<any> {
    
    return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeeportal/GetEmployeesNotQuit?from=${from}`, this.httpOptions);
  }

  getEmployeesSupervisingNotQuit(isAdmin: boolean, from: string): Observable<any> {
    
    return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeeportal/GetEmployeesSupervisingNotQuit?isAdmin=${isAdmin}&from=${from}`, this.httpOptions);
  }

  getEmployeesSupervising(isAdmin: boolean): Observable<any> {
    
    return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeeportal/GetEmployeesSupervising?isAdmin=${isAdmin}`, this.httpOptions);
  }

  getSupervisors(): Observable<any> {
    
    return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeeportal/GetSupervisors`, this.httpOptions);
  }

  getTimeTypes(): Observable<any> {
    return this.http.get<any>(this.configService.config.employeeUrl + "/api/time/GetTimeTypes", this.httpOptions);
  }
  
  getDayPlans(): Observable<any> {
    
    let httpOptionsEmployee = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-employee-key',
        'SessionId': this.userService.sessionId
      })
    };
    return this.http.get<any>(this.configService.config.employeeUrl + "/api/employeeportal/GetDayPlans", httpOptionsEmployee);
  }
  
  getEmployeeDayPlan(employeeId: number, date: string): Observable<any> {
    
    let httpOptionsTime = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-time-key',
        'SessionId': this.userService.sessionId
      })
    };
    return this.http.get<any>(this.configService.config.timeUrl + `/api/Calculate/GetEmployeeDayPlan?employeeId=${employeeId}&date=${date}`, httpOptionsTime);
  }

  /* ADMIN */
  getOverview_Admin(from: string, to: string, selectedSupervisorId: number, showEmployeesWithoutTimes: boolean, showQuitEmployees: boolean, isAdmin: boolean): Observable<any> {
    return this.http.get<any>(this.configService.config.employeeUrl + `/api/employeeportal/GetAdminOverview?from=${from}&to=${to}&selectedSupervisorId=${selectedSupervisorId}&showEmployeesWithoutTimes=${showEmployeesWithoutTimes}&showQuitEmployees=${showQuitEmployees}&isAdmin=${isAdmin}`, this.httpOptions);
  }

  approveOverview_Admin(from: string, to: string, ids: number[]): Observable<any> {
    
    let employeeIds = "";
    ids.forEach(employeeId => {
      
      employeeIds += "employeeIds=" + employeeId;
      if (employeeId != ids[ids.length - 1]) {
        employeeIds += "&";
      }
    });

    return this.http.post<any>(this.configService.config.timeUrl + `/api/employeeportal/ApproveAdminOverview?from=${from}&to=${to}&${employeeIds}`, [], this.httpOptions);
  }
  
  getWeekApproval(viewModel: any): Observable<any> {
    
    let httpOptionsProject = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-project-key',
        'SessionId': this.userService.sessionId
      })
    };
    return this.http.post<any>(this.configService.config.projectUrl + "/api/project/GetVMWeekApproval", viewModel, httpOptionsProject);
  }

  getAmlWeekEmployees(fromDate, toDate, selectedEmployeeId) {
    return this.http.get<any>(this.configService.config.employeeUrl + `/api/EmployeePortal/GetAmlWeekEmployees?from=${fromDate}&to=${toDate}&employeeId=${selectedEmployeeId}`, this.httpOptions);

  }
}
